module.exports = __webpack_public_path__ + "img/1.ea863e47.jpg";